export const styles = {
  optionToneStyles: {
    success: {
      background: '#ECFDF5',
      border: '1px solid #A7F3D0',
      color: '#047857',
    },
    info: {
      background: '#EFF6FF',
      border: '1px solid #BFDBFE',
      color: '#1D4ED8',
    },
    danger: {
      background: '#FEF2F2',
      border: '1px solid #FECACA',
      color: '#B91C1C',
    },
    warning: {
      background: '#FFFBEB',
      border: '1px solid #FDE68A',
      color: '#B45309',
    },
    successMuted: {
      background: '#F0FDF4',
      border: '1px dashed #86EFAC',
      color: '#047857',
    },
    neutral: {
      background: '#F9FAFB',
      border: '1px solid #E5E7EB',
      color: '#4B5563',
    },
  },
  statusToneStyles: {
    success: {
      background: '#ECFDF5',
      border: '1px solid #A7F3D0',
      color: '#059669',
    },
    info: {
      background: '#EFF6FF',
      border: '1px solid #BFDBFE',
      color: '#1D4ED8',
    },
    danger: {
      background: '#FEF2F2',
      border: '1px solid #FECACA',
      color: '#DC2626',
    },
    warning: {
      background: '#FFFBEB',
      border: '1px solid #FDE68A',
      color: '#B45309',
    },
    neutral: {
      background: '#F3F4F6',
      border: '1px solid #E5E7EB',
      color: '#4B5563',
    },
  },
  scoreMeta: {
    success: {
      background: 'linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%)',
      border: '1px solid #86EFAC',
      color: '#047857',
      accent: '#10B981',
    },
    warning: {
      background: 'linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%)',
      border: '1px solid #FDE68A',
      color: '#B45309',
      accent: '#F59E0B',
    },
    danger: {
      background: 'linear-gradient(135deg, #FEF2F2 0%, #FEE2E2 100%)',
      border: '1px solid #FECACA',
      color: '#B91C1C',
      accent: '#EF4444',
    },
  },
  responseStatusMeta: {
    active: {
      background: '#ECFDF5',
      border: '1px solid #A7F3D0',
      color: '#059669',
    },
    expired: {
      background: '#FEF2F2',
      border: '1px solid #FECACA',
      color: '#DC2626',
    },
  },
  mediaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: 12,
    marginTop: 12,
  },
  attachmentFallbackCard: {
    border: '1px solid #E5E7EB',
    borderRadius: 14,
    padding: 12,
    background: '#F9FAFB',
  },
  attachmentFallbackName: {
    marginTop: 8,
    fontSize: 13,
    color: '#4B5563',
  },
  mediaButtonBase: {
    border: '1px solid #E5E7EB',
    borderRadius: 14,
    overflow: 'hidden',
    cursor: 'pointer',
    padding: 0,
  },
  imageButton: {
    background: '#FFFFFF',
  },
  imageThumb: {
    height: 120,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: '#F3F4F6',
  },
  mediaName: {
    padding: 10,
    fontSize: 12,
    textAlign: 'left',
    wordBreak: 'break-word',
  },
  imageName: {
    color: '#374151',
  },
  videoButton: {
    background: '#111827',
    color: '#FFFFFF',
  },
  videoThumb: {
    width: '100%',
    height: 120,
    objectFit: 'cover',
    display: 'block',
    background: '#111827',
  },
  fileButton: {
    border: '1px solid #E5E7EB',
    borderRadius: 14,
    padding: 12,
    background: '#F9FAFB',
    cursor: 'pointer',
    textAlign: 'left',
  },
  fileName: {
    marginTop: 8,
    fontSize: 13,
    color: '#374151',
    wordBreak: 'break-word',
  },
  modalOverlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15, 23, 42, 0.38)',
    zIndex: 10002,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  previewOverlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 10003,
    background: 'rgba(17, 24, 39, 0.65)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 14,
  },
  previewDialog: {
    width: 'min(980px, 100%)',
    height: 'min(88vh, 760px)',
    background: '#fff',
    borderRadius: 14,
    border: '1px solid #E5E7EB',
    boxShadow: '0 28px 80px rgba(0,0,0,0.22)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  previewHeader: {
    padding: '12px 14px',
    borderBottom: '1px solid #E5E7EB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  previewNameWrap: {
    minWidth: 0,
  },
  previewName: {
    fontWeight: 800,
    fontSize: 13,
    color: '#111827',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 700,
  },
  previewActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  previewDownloadButton: {
    border: '1px solid #E5E7EB',
    background: '#FFFFFF',
    cursor: 'pointer',
    borderRadius: 10,
    width: 40,
    height: 40,
  },
  previewCloseButton: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 20,
    lineHeight: 1,
    color: '#111827',
    padding: 6,
  },
  previewBody: {
    flex: 1,
    background: '#111827',
  },
  previewLoading: {
    padding: 16,
    color: '#FFFFFF',
  },
  previewInfoWrap: {
    padding: 16,
    background: '#F9FAFB',
    height: '100%',
  },
  previewError: {
    color: '#DC2626',
    fontWeight: 700,
  },
  previewInfoText: {
    color: '#6B7280',
  },
  previewFrame: {
    width: '100%',
    height: '100%',
    border: 0,
    background: '#F9FAFB',
  },
  previewVideoWrap: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#111827',
  },
  previewVideo: {
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    display: 'block',
    background: '#111827',
  },
  modalDialog: {
    width: 'min(1400px, calc(100vw - 64px))',
    height: 'min(92vh, 980px)',
    background: '#FFFFFF',
    borderRadius: 16,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 24px 80px rgba(15, 23, 42, 0.22)',
  },
  modalHeader: {
    padding: '16px 20px 14px',
    borderBottom: '1px solid #E5E7EB',
  },
  modalHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 16,
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: '#111827',
  },
  modalDivider: {
    marginTop: 10,
    borderTop: '1px solid #E5E7EB',
    width: '100%',
  },
  infoPillsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 14,
    marginTop: 8,
    color: '#6B7280',
    fontSize: 13,
  },
  infoPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  infoPillStrong: {
    color: '#374151',
  },
  closeButton: {
    width: 40,
    height: 40,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: '#6B7280',
  },
  toolbar: {
    padding: '10px 20px',
    borderBottom: '1px solid #E5E7EB',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    alignItems: 'center',
  },
  searchBox: {
    flex: '1 1 420px',
    height: 40,
    border: '1px solid #DDE3EA',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '0 12px',
  },
  searchInput: {
    width: '100%',
    border: 'none',
    outline: 'none',
    fontSize: 13,
    color: '#111827',
  },
  filterButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 600,
    color: '#4B5563',
  },
  filterBox: {
    width: 28,
    height: 24,
    borderRadius: 6,
    border: '1px solid #93C5FD',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFFFF',
  },
  toolbarAction: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 700,
    color: '#1F2937',
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: 24,
    background: '#F8FAFC',
  },
  centeredMessage: {
    padding: '32px 0',
    textAlign: 'center',
    color: '#6B7280',
  },
  responseCard: {
    border: '1px solid #DDE3EA',
    borderRadius: 18,
    background: '#FFFFFF',
    padding: 18,
    marginBottom: 14,
  },
  responseHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  responseHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  responseTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: '#111827',
  },
  scoreAccent: {
    width: 10,
    height: 10,
    borderRadius: 999,
    flex: '0 0 auto',
  },
  responseActions: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
  },
  primaryActionButton: {
    height: 36,
    padding: '0 16px',
    borderRadius: 12,
    border: 'none',
    background: '#163A5F',
    color: '#FFFFFF',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
  },
  secondaryActionButton: {
    height: 36,
    padding: '0 16px',
    borderRadius: 12,
    border: '1px solid #DDE3EA',
    background: '#F8FAFC',
    color: '#374151',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
  },
  responseDivider: {
    marginTop: 12,
    borderTop: '1px solid #E5E7EB',
  },
  responseInfoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: 10,
    marginTop: 12,
  },
  responseInfoCard: {
    background: '#F8FAFC',
    borderRadius: 14,
    padding: '10px 12px',
    border: '1px solid #EEF2F7',
  },
  responseInfoLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: '#8B8B8B',
    fontSize: 12,
    marginBottom: 4,
  },
  responseInfoValue: {
    color: '#374151',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.35,
    wordBreak: 'break-word',
  },
  expandedSection: {
    marginTop: 18,
    paddingTop: 18,
    borderTop: '1px solid #E5E7EB',
  },
  questionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 14,
  },
  questionCard: {
    border: '1px solid #E5E7EB',
    borderRadius: 14,
    padding: 14,
    background: '#FFFFFF',
  },
  questionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 10,
    marginBottom: 8,
    alignItems: 'flex-start',
  },
  questionTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.35,
  },
  questionDivider: {
    borderTop: '1px solid #E5E7EB',
    marginBottom: 10,
  },
  optionsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  optionCard: {
    borderRadius: 12,
    padding: '10px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  optionLabel: {
    fontSize: 14,
    lineHeight: 1.4,
    flex: '1 1 auto',
    minWidth: 0,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  optionMeta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
  },
  optionTag: {
    fontSize: 11,
    fontWeight: 800,
    textTransform: 'uppercase',
  },
  questionAnswerBox: {
    borderRadius: 12,
    background: '#F9FAFB',
    border: '1px solid #F3F4F6',
    padding: 12,
    color: '#4B5563',
    fontSize: 14,
    lineHeight: 1.45,
  },
  questionSection: {
    marginTop: 12,
  },
  questionSectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: '#6B7280',
    marginBottom: 8,
  },
  chipsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  resultChip: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: 30,
    padding: '6px 10px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
  },
};
